import type { CrossSellingModalScenarioContent } from '@front-platform/content-builder';
import { DoodProductModel } from '@core/models/product.model';
import { CROSS_SELLING_MODAL_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import type { Cb2PreviewScenarioPayload } from '@core/services/cb2-preview/cb2-preview-protocol';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { resolvePreviewScenarioForBloc } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';

/**
 * Studio preview supplies the proposed products. Outside preview, the modal
 * keeps the products passed when it was opened.
 */
export function resolveCrossSellingModalProducts(input: {
  isPreview: boolean;
  scenarios: Readonly<Record<string, Cb2PreviewScenarioPayload>>;
  blocKey: string | null | undefined;
  runtimeProducts: DoodProductModel[] | null | undefined;
}): DoodProductModel[] {
  if (input.isPreview) {
    const content = previewScenarioData<CrossSellingModalScenarioContent>(
      resolvePreviewScenarioForBloc(input.scenarios, input.blocKey, CROSS_SELLING_MODAL_COMPONENT),
      CROSS_SELLING_MODAL_COMPONENT,
    );
    if (content) {
      return [...content.products] as unknown as DoodProductModel[];
    }
  }

  return input.runtimeProducts ?? [];
}
